export enum FeatureFlag {
  CardDisputeManagement = 'card-dispute-management',
  CustomRoleUsersPermissionEnabled = 'custom-role-users-permission-enabled',
  DashboardCustomRoles = 'dashboard-custom-roles',
  EnableAchTransferBatches = 'enable-ach-transfer-batches',
  EnableCustomCSVStatements = 'enable-custom-csv-statements',
  EnableDashboardSSO = 'enable-dashboard-sso',
  EnableDeviceMFA = 'enable-device-mfa',
  EnableExpeditedCheckDelivery = 'enable-expedited-check-delivery',
  EnableExternalApps = 'enable-external-apps',
  EnableLiquidationRouteAPIs = 'enable-liquidation-route-apis',
  EnableLoanSearch = 'enable-loan-search',
  EnableNotificationConfiguration = 'enable-notification-configuration',
  EnablePaniniCheckScanner = 'enable-panini-check-scanner',
  EnablePasskeyAuth = 'enable-passkey-auth',
  EnableTransferApprovalPage = 'enable-transfer-approval-page',
  EnableTransferBatches = 'enable-transfer-batches',
  EnableTransferReviewBatches = 'enable-transfer-review-batches',
  HasInternationalWires = 'has-international-wires',
}
